import { render, staticRenderFns } from "./RationaleForRunning.vue?vue&type=template&id=456f38f6&"
import script from "./RationaleForRunning.vue?vue&type=script&lang=js&"
export * from "./RationaleForRunning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports